import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    //common
    user: undefined,

    // student section
    cv: undefined,
    follows: [],

    // company section
    areas: [],
    macroareas: [],
    followers: []
}

export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        storeUser: (state, action) => {
            state.user = action.payload
        },
        storeCv: (state, action) => {
            state.cv = action.payload
        },
        storeFollows: (state, action) => {
            state.follows = action.payload
        },
        storeAreas: (state, action) => {
            state.areas = action.payload
        },
        storeMacroareas: (state, action) => {
            state.macroareas = action.payload
        },
        storeFollowers: (state, action) => {
            state.followers = action.payload.followers
        },
        resetProfile: state => initialState
    }
});

export const {
    storeUser,
    storeCv,
    storeFollows,
    storeAreas,
    storeMacroareas,
    storeFollowers,
    resetProfile
} = profileSlice.actions;

// selectors
export const selectUser = state => state.profile.user;
export const selectName = state => state.profile.user?.name;
export const selectRole = state => state.profile.user?.role;
export const selectCv = state => state.profile.cv;
export const selectFollows = state => state.profile.follows;
export const selectAreas = state => state.profile.areas;
export const selectMacroareas = state => state.profile.macroareas;
export const selectFollowers = state => state.profile.followers;

export default profileSlice.reducer;
